module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter ListOfIllustrations exclude-auto page-open-auto",
    attrs: {
      "id": "ListOfIllustrations1"
    }
  }, [_c('div', {
    staticClass: "title-block exclude-auto",
    attrs: {
      "id": "title-block4"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_ix"
    }
  }), _c('h1', {
    attrs: {
      "id": "h15"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781783784370_tableofcontents"
    }
  }, [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "firstpara2"
    }
  }, [_c('span', [_vm._v("PLATE SECTION")])]), _vm._v(" "), _c('div', {
    staticClass: "list-named list-illustrations exclude-auto",
    attrs: {
      "id": "list-illustrations1"
    }
  }, [_c('p', {
    attrs: {
      "id": "p19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("1")]), _vm._v(" Completed Dentdale gloves, January 2017")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("2")]), _vm._v(" Fisher lassies at Yarmouth, knitting in front of a pile of ‘Yarmouth swills’")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("3")]), _vm._v(" Author wears her Pussyhat at anti-Trump protest, March 2017")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("4")]), _vm._v(" "), _c('i', [_vm._v("Virginia Woolf")]), _vm._v(" by Vanessa Bell, 1912")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("5")]), _vm._v(" Temperature and knitting yarn chart, Marsha Willey")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("6")]), _vm._v(" Gairloch stockings, Gairloch Museum")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("7")]), _vm._v(" Uist Wool’s Canach yarn")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("8")]), _vm._v(" Yarn in production at Uist Wool")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("9")]), _vm._v(" Military hose, Highland Folk Museum")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("10")]), _vm._v(" Knitting frame, Ruddington, Framework Knitters Museum")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("11")]), _vm._v(" Dubied hand-flat machine, Heriot-Watt School of Textiles and Design")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("12")]), _vm._v(" Author in handmade bikini, Northumberland, June 2017")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("13")]), _vm._v(" Completed child’s cricket slipover, August 2017")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("14")]), _vm._v(" Author and friend Elly Murrell with raw fleece")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("15")]), _vm._v(" Nålebound Jorvik sock, 2017")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("16")]), _vm._v(" Jersey spinning wheel, Hamptonne Country Life Museum, Jersey")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p34"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_x"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_x"
    }
  }), _c('p', {
    attrs: {
      "id": "p35"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("17")]), _vm._v(" ‘Grey-belly’ and navy sleeves knitted with Jersey patterns, Hamptonne Country Life Museum, Jersey")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("18")]), _vm._v(" 1920s knitwear display, Shetland Museum, Lerwick")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("19")]), _vm._v(" Jumper knitted from handspun yarn dyed with ground elder, Shetland Wool Week, September 2017")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("20")]), _vm._v(" Madder dyeing, Julia Billings’s Workshop, Shetland Wool Week, 2017")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("21")]), _vm._v(" Fair Isle fisherman’s kep, Shetland Museum, Lerwick")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("22")]), _vm._v(" Rib and loop of replica Monmouth cap, October 2017")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("23")]), _vm._v(" Detail from "), _c('i', [_vm._v("Woolcraft: A Practical Guide to Knitting & Crochet with Beehive & White Heather Knitting Wools")]), _vm._v(", November 2017")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("24")]), _vm._v(" Eliza Lewis’s funeral stockings, St Fagans National Museum of History, Cardiff")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("25")]), _vm._v(" Lace shawl knitted by Betsy Williamson, Ollaberry, September 2017, Shetland")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("26")]), _vm._v(" Border and edging of baby hap, 2017")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("27")]), _vm._v(" Completed gansey detail, January 2018")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_platepage#figure28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("28")]), _vm._v(" Author’s father, Michael Rutter, in his gansey, January 2018")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "firstpara3"
    }
  }, [_c('span', [_vm._v("ILLUSTRATIONS IN TEXT")])]), _vm._v(" "), _c('div', {
    staticClass: "list-named list-illustrations exclude-auto",
    attrs: {
      "id": "list-illustrations3"
    }
  }, [_c('p', {
    attrs: {
      "id": "p47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781783784370_other_02#image2"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("1")]), _vm._v(" Fleece on a wire fence, Heald Brow, Cumbria")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781783784370_chapter_01#image3"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("2")]), _vm._v(" Knitting fingers of Dentdale gloves")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781783784370_chapter_02#image4"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("3")]), _vm._v(" H. Inglis gloves")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781783784370_chapter_03#image5"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("4")]), _vm._v(" Rib of Dad’s gansey with needles")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_04#image6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("5")]), _vm._v(" Robertson family of Buckhaven, Fife, knitting, baiting lines and mending nets")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_04#image7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("6")]), _vm._v(" Murray brothers and crew, Cellardyke, c. 1900")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_05#image8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("7")]), _vm._v(" A Pussyhat")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_06#image9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("8")]), _vm._v(" "), _c('i', [_vm._v("Les Tricoteuses Jacobines")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p1454"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_07#image10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("9")]), _vm._v(" Gairloch stocking with Glenfeshie behind")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p55"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_xi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_xi"
    }
  }), _c('p', {
    attrs: {
      "id": "p56"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_08#image11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("10")]), _vm._v(" Gairloch, looking south")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_09#Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("11")]), _vm._v(" A not-so-itsy-bitsy bikini")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_10#image13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("12")]), _vm._v(" Jedburgh Abbey")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_10#image14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("13")]), _vm._v(" Pattern from "), _c('i', [_vm._v("Practical Knitting Illustrated")]), _vm._v(" for an Easy to Wear Beach Suit")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_11#image15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("14")]), _vm._v(" Cotswold sheep")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_12#image16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("15")]), _vm._v(" Carders, niddy-noddy, raw fleece, bobbins")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_12#image17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("16")]), _vm._v(" ‘The Cathedral of the Cotswolds’, the Church of St Peter and St Paul, Northleach, Gloucestershire")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_12#image18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("17")]), _vm._v(" Scarborough Cricket Club")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_12#image19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("18")]), _vm._v(" Cricket jumper pattern by "), _c('i', [_vm._v("Wendy, c.")]), _vm._v(" 1980")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_13#image20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("19")]), _vm._v(" Starting a Jorvik sock")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_14#image21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("20")]), _vm._v(" Nålebinding needle and Léttlopi yarn")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_14#image22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("21")]), _vm._v(" Detail of latched needle, Imperia knitting machine")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_15#image23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("22")]), _vm._v(" Jersey spinning wheel, Hamptonne Country Life Museum")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_16#image24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("23")]), _vm._v(" Polperro harbour, Cornwall")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_16#image25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("24")]), _vm._v(" "), _c('i', [_vm._v("The Docker")]), _vm._v(", statue by Colin Miller, Jersey")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_16#image26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("25")]), _vm._v(" Detail of an undyed Guernsey")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_17#image27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("26")]), _vm._v(" Shetland scarf detail")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_18#image28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("27")]), _vm._v(" Hay’s Dock, Lerwick, Shetland")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_18#image29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("28")]), _vm._v(" Anderson & Co. advertisement in "), _c('i', [_vm._v("Manson’s Shetland Almanac and Directory")]), _vm._v(", 1892")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_18#image30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("29")]), _vm._v(" Oliver Henry and Shetland fleeces at Jamieson & Smith, Lerwick, Shetland")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_19#image31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("30")]), _vm._v(" A skein of Garthenor Ryeland yarn")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_20#image32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("31")]), _vm._v(" Male Welsh stocking knitter, Bala")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_21#image33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("32")]), _vm._v(" Completed miniature hap")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_22#image34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("33")]), _vm._v(" Chrissie Cheyne, Brig o’ Wass, Shetland")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_22#image35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("34")]), _vm._v(" Lace hap knitted by Betsy Williamson, Ollaberry")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_23#image36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("35")]), _vm._v(" Knitting needles laid down beside yarn")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781783784370_chapter_24#image37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "style7"
  }, [_vm._v("36")]), _vm._v(" Preston North End fans, 1954")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara",
    attrs: {
      "id": "p83"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagebreak-rw_xii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_xii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_xii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagebreak-rw_xii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29a15a7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781783784370_listofillustrations.vue
// module id = 72
// module chunks = 0